import React, { useEffect, useState } from 'react'
import { Box, Collapse, CircularProgress } from '@mui/material'
import { useNavigate } from 'react-router-dom'
import SanitizeHtml from '../../Base/SanitizeHtml/SanitizeHtml'
import constants from '../../../../js/lib/constants'
import { useSelector, useDispatch } from 'react-redux'
import { setStep } from '../../../../js/lib/redux/slices/booking'
import SidebarCosts from './SidebarCosts'
import isTransmissionAuto from '../../../../js/helpers/isTransmissionAuto'

const Sidebar = ({ handleContinue, isLoading }) => {
  const isBooking = window.bookingData ? true : false
  const { dictionary, records } = isBooking
    ? window.bookingData
    : window.modifyData
  const { brands, types } = records
  const { pageNumber, navigateTo } = constants.booking

  const navigate = useNavigate()

  const [showDetails, setShowDetails] = useState(false)
  const {
    step,
    selectedVehicle,
    isPrepaid: isPrepaidStore,
    modifiedPrices,
    mbData,
    type,
    milesNBonusAccount,
  } = useSelector((state) => state.booking)
  const dispatch = useDispatch()

  // Add null check to prevent errors when selectedVehicle is null
  const { brandName, car } = selectedVehicle || {}
  const { prepaidPrice, returnPrice } = car || {}

  // useEffect(() => {
  // console.log('Selected vehicle', selectedVehicle)=
  // }, [])

  const handleEditExtras = () => {
    dispatch(setStep(pageNumber.extras))
    navigate(navigateTo.extras)
  }

  const handleChangeVehicle = () => {
    dispatch(setStep(pageNumber.vehicles))
    navigate(navigateTo.vehicles)
  }

  const toggleContent = () => {
    setShowDetails(!showDetails)
  }

  const getBrand = () => {
    return brands?.find((b) => b.brandCode === brandName)
  }

  const prepaidIncludes = () => {
    // Add null check for prepaidPrice and prepaidIncludes
    if (!prepaidPrice || !prepaidPrice.prepaidIncludes) return []
    const includes = prepaidPrice.prepaidIncludes.split(',')
    return includes
  }

  const returnIncludes = () => {
    // Add null check for returnPrice and returnIncludes
    if (!returnPrice || !returnPrice.returnIncludes) return []
    const includes = returnPrice.returnIncludes.split(',')
    return includes
  }

  return (
    <>
      <div className="b-booking-sidebar__title">
        <span>{dictionary.asideTitle}</span>
        {isBooking && (
          <button
            type="button"
            className="btn-clear b-booking-sidebar__title__btn"
            onClick={handleChangeVehicle}>
            {dictionary.asideChangeVehicleLabel}
          </button>
        )}
      </div>
      <div className="b-booking-sidebar">
        <div className="b-booking-sidebar__main">
          <div className="b-booking-sidebar__header">
            <div className="b-booking-sidebar__header__model">
              <h2 className="h2">{car?.model}</h2>
              {car?.similarText && <span>{car?.similarText}</span>}
            </div>
            <div className="b-booking-sidebar__header__logo">
              {getBrand() && (
                <img
                  src={getBrand().brandLogoLight}
                  alt={getBrand().brandCode}
                  loading="lazy"
                />
              )}
            </div>
          </div>
          <div className="b-booking-sidebar__body">
            <img
              className="b-booking-sidebar__car-image"
              src={car?.modelImage}
              alt={car?.model}
              loading="lazy"
            />

            {/* FIX BIG SUITCASE ICON !!!! */}
            <div className="b-booking-sidebar__view-details">
              <Collapse in={showDetails}>
                <Box className="b-booking-sidebar__view-details__content">
                  <ul className="b-booking-sidebar__view-details__list">
                    {car?.passengers && (
                      <li>
                        <div className="pair">
                          <i className="icon-passenger"></i>
                          <span>{car?.passengers}</span>
                        </div>
                      </li>
                    )}
                    {(car?.smallLuggage > 0 || car?.bigLuggage > 0) && (
                      <li>
                        {car?.bigLuggage > 0 && (
                          <div className="pair">
                            <i className="icon-suitcase"></i>
                            <span>x{car?.bigLuggage}</span>
                          </div>
                        )}
                        {car?.smallLuggage > 0 && (
                          <div className="pair">
                            <i className="icon-suitcase"></i>
                            <span>x{car?.smallLuggage}</span>
                          </div>
                        )}
                      </li>
                    )}
                    {car?.acriss && (
                      <li>
                        <div className="pair">
                          <i className="icon-transmission"></i>
                          <span>
                            {isTransmissionAuto({
                              acriss: car?.acriss,
                            })
                              ? dictionary.transmissionAutomatic
                              : dictionary.transmissionManual}
                          </span>
                        </div>
                      </li>
                    )}
                    <li>
                      <div className="pair">
                        <i className="icon-ac"></i>
                        {car?.ac ? (
                          <span>{dictionary.acYes}</span>
                        ) : (
                          <span>{dictionary.acNo}</span>
                        )}
                      </div>
                    </li>
                    {car?.autonomy && (
                      <li>
                        <div className="pair">
                          <i className="icon-battery-charging"></i>
                          <span>{car?.autonomy}</span>
                        </div>
                      </li>
                    )}
                  </ul>

                  <>
                    <div className="b-booking-sidebar__divider--dashed"></div>
                    <ul className="b-booking-sidebar__view-details__extras">
                      {isPrepaidStore
                        ? prepaidIncludes().map((extra, index) => (
                            <li key={index}>
                              <i className="icon-check"></i>
                              <span>{extra}</span>
                            </li>
                          ))
                        : returnIncludes().map((extra, index) => (
                            <li key={index}>
                              <i className="icon-check"></i>
                              <span>{extra}</span>
                            </li>
                          ))}
                    </ul>
                  </>
                </Box>
              </Collapse>
              <div
                className={`b-booking-sidebar__view-details__btn ${
                  showDetails ? 'show' : ''
                }`}
                onClick={toggleContent}>
                {showDetails
                  ? dictionary.asideHideDetails
                  : dictionary.asideShowDetails}
                <i className="icon-arrow-down arrow" />
              </div>
            </div>
          </div>
        </div>
        <div className="b-booking-sidebar__sticky">
          {isLoading && (
            <div className="b-booking-sidebar__loading">
              <CircularProgress />
            </div>
          )}
          <SidebarCosts
            step={step}
            mbData={mbData}
            selectedVehicle={selectedVehicle}
            modifiedPrices={modifiedPrices}
            isPrepaid={isPrepaidStore}
            type={type}
            milesNBonusAccount={milesNBonusAccount}
            handleEditExtras={handleEditExtras}
          />

          {step !== pageNumber.payment && isBooking && (
            <div className="b-booking-sidebar__footer">
              <button
                type="submit"
                className="btn btn-primary btn-full-width"
                onClick={handleContinue}
                title={dictionary.asideProceedLabel}>
                {dictionary.asideProceedLabel}
              </button>

              {!selectedVehicle?.isGREngine && (
                <SanitizeHtml
                  tag={'div'}
                  className="b-booking-sidebar__footer__note"
                  html={dictionary.asideNoteText}
                />
              )}
            </div>
          )}
        </div>
      </div>
    </>
  )
}

export default Sidebar
